/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
// reactstrap components
import {
  Button,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";
import {RiFacebookFill} from "react-icons/ri";

class SimpleFooter extends React.Component {
  render() {
    return (
      <>
        <footer className=" footer">
          <Container>
            {/*{!sessionStorage.getItem("customer") && <>*/}
            {/*  <Row className=" row-grid align-items-center mb-5">*/}
            {/*    <Col lg="9">*/}
            {/*      <h3 className=" text-primary font-weight-light mb-2">*/}
            {/*        Thank you for being here.*/}
            {/*      </h3>*/}
            {/*      <h4 className=" mb-0 font-weight-light">*/}
            {/*        Whether you have a question, feedback, or just want to say hello, we'd love to hear from you.*/}
            {/*        Please see our <a href="https://www.facebook.com/profile.php?id=100094188022581" target="_blank"*/}
            {/*                          rel="noreferrer">Facebook page</a> or you can email us at <a*/}
            {/*          href="mailto:hello@theworshipbible.church">hello@theworshipbible.church</a>.*/}
            {/*      </h4>*/}
            {/*    </Col>*/}
            {/*    <Col className="text-lg-center btn-wrapper" lg="3">*/}
            {/*      /!*<Button*!/*/}
            {/*      /!*  className="btn-icon-only rounded-circle"*!/*/}
            {/*      /!*  color="twitter"*!/*/}
            {/*      /!*  href="https://twitter.com/creativetim"*!/*/}
            {/*      /!*  id="tooltip475038074"*!/*/}
            {/*      /!*     target="_blank" rel="noreferrer"*!/*/}
            {/*      /!*>*!/*/}
            {/*      /!*  <span className="btn-inner--icon">*!/*/}
            {/*      /!*    <i className="fa fa-twitter" />*!/*/}
            {/*      /!*  </span>*!/*/}
            {/*      /!*</Button>*!/*/}
            {/*      /!*<UncontrolledTooltip delay={0} target="tooltip475038074">*!/*/}
            {/*      /!*  Follow us*!/*/}
            {/*      /!*</UncontrolledTooltip>*!/*/}
            {/*      <Button*/}
            {/*          className="btn-icon-only rounded-circle ml-1"*/}
            {/*          color="facebook"*/}
            {/*          href="https://www.facebook.com/profile.php?id=100094188022581"*/}
            {/*          id="tooltip837440414"*/}
            {/*          target="_blank" rel="noreferrer"*/}
            {/*      >*/}
            {/*      <span className="btn-inner--icon">*/}
            {/*        <RiFacebookFill color="facebook" size="16"/>*/}
            {/*      </span>*/}
            {/*      </Button>*/}
            {/*      <UncontrolledTooltip delay={0} target="tooltip837440414">*/}
            {/*        Like us*/}
            {/*      </UncontrolledTooltip>*/}
            {/*      /!*<Button*!/*/}
            {/*      /!*  className="btn-icon-only rounded-circle ml-1"*!/*/}
            {/*      /!*  color="instagram"*!/*/}
            {/*      /!*  href="https://dribbble.com/creativetim"*!/*/}
            {/*      /!*  id="tooltip829810202"*!/*/}
            {/*      /!*     target="_blank" rel="noreferrer"*!/*/}
            {/*      /!*>*!/*/}
            {/*      /!*  <span className="btn-inner--icon">*!/*/}
            {/*      /!*    <i className="fa fa-instagram" />*!/*/}
            {/*      /!*  </span>*!/*/}
            {/*      /!*</Button>*!/*/}
            {/*      /!*<UncontrolledTooltip delay={0} target="tooltip829810202">*!/*/}
            {/*      /!*  Follow us*!/*/}
            {/*      /!*</UncontrolledTooltip>*!/*/}
            {/*    </Col>*/}
            {/*  </Row>*/}
            {/*  <hr/>*/}
            {/*</>}*/}
            <Row className=" align-items-center justify-content-md-between pb-3">
              <Col md="12">
                <Row className="pt-3 pb-4">
                  <Col md="3">
                    <h6 className="text-uppercase text-muted font-weight-bold mb-3">Explore Worship</h6>
                    <Nav vertical className="footer-nav">
                      <NavItem><NavLink href="/worship/i-want-to-worship">I Want to Worship</NavLink></NavItem>
                      <NavItem><NavLink href="/worship/worship-songs-by-bible-passage">Worship Songs by Bible Passage</NavLink></NavItem>
                      <NavItem><NavLink href="/worship/help-creating-a-worship-list">Help Creating a Worship List</NavLink></NavItem>
                      {/*<NavItem><NavLink href="/worship/themes">Worship Themes in Scripture</NavLink></NavItem>*/}
                    </Nav>
                  </Col>

                  <Col md="3">
                    <h6 className="text-uppercase text-muted font-weight-bold mb-3">Plan Worship</h6>
                    <Nav vertical className="footer-nav">
                      <NavItem><NavLink href="/worship/plan-worship-for-your-next-service">Plan Worship for your next Service</NavLink></NavItem>
                      <NavItem><NavLink href="/worship/worship-planning-using-the-lectionary">Worship Planning Using the Lectionary</NavLink></NavItem>
                      {/*<NavItem><NavLink href="/playlist/builder">Build a Worship Playlist</NavLink></NavItem>*/}
                      {/*<NavItem><NavLink href="/search">Scripture-Based Song Discovery</NavLink></NavItem>*/}
                    </Nav>
                  </Col>

                  <Col md="3">
                    <h6 className="text-uppercase text-muted font-weight-bold mb-3">Use The Worship Bible</h6>
                    <Nav vertical className="footer-nav">
                      {/*<NavItem><NavLink href="/barnabas">Ask Barnabas</NavLink></NavItem>*/}
                      {/*<NavItem><NavLink href="/songs">Search Songs</NavLink></NavItem>*/}
                      {/*<NavItem><NavLink href="/songbooks">Songs by Song Book</NavLink></NavItem>*/}
                      <NavItem><NavLink href="/scripture/choose-passages">Songs by Scripture</NavLink></NavItem>
                      <NavItem><NavLink href="/themes/choose-themes">Songs by Theme</NavLink></NavItem>
                      <NavItem><NavLink href="/lectionary/choose-lectionary">Song by Lectionary</NavLink></NavItem>
                      <NavItem><NavLink href="/songs">Songs by Scripture Hierarchy</NavLink></NavItem>
                      <NavItem><NavLink href="/themes">Songs by Biblical Theme</NavLink></NavItem>
                      <NavItem><NavLink href="/authors">Songs by Author</NavLink></NavItem>
                    </Nav>
                  </Col>

                  <Col md="3">
                    <h6 className="text-uppercase text-muted font-weight-bold mb-3">About & Trust</h6>
                    <Nav vertical className="footer-nav">
                      <NavItem><NavLink href="/about-us">About The Worship Bible</NavLink></NavItem>
                      <NavItem><NavLink href="/contact-us">Contact Us</NavLink></NavItem>
                      <NavItem><NavLink href="/privacy-policy">Privacy Policy</NavLink></NavItem>
                      <NavItem><NavLink href="/terms-and-conditions">Terms &amp; Conditions</NavLink></NavItem>
                      <NavItem><NavLink href="/security">Security &amp; Data Protection</NavLink></NavItem>
                    </Nav>
                  </Col>
                </Row>
              </Col>
              <Col md="12">
                <div className="copyright text-muted text-center text-md-center">
                  © {new Date().getFullYear()}{" "}
                  <a href="/" className="font-weight-bold">
                    The Worship Bible
                  </a>
                  . Helping churches and individuals worship God faithfully through Scripture.
                </div>
              </Col>
            </Row>
            <Row className="mb-2">
              &nbsp;
            </Row>
          </Container>
        </footer>
      </>
    );
  }
}

export default SimpleFooter;
